import { Badge as AntBadge, type BadgeProps as AntBadgeProps } from 'antd'

export type BadgeProps = Omit<AntBadgeProps, 'color'> & {
  color?: 'primary' | 'danger'
}

export const Badge = ({ color = 'danger', ...props }: BadgeProps) => (
  <AntBadge
    style={
      color === 'primary'
        ? {
            color: '#0085FF',
            backgroundColor: '#E6F3FF',
          }
        : {}
    }
    {...props}
  />
)

Badge.Ribbon = AntBadge.Ribbon
